import React from "react";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Breadcrumb = {
    label: string;
    href?: string; // Optional href for links
};

interface TitleBarProps {
    breadcrumbs?: Breadcrumb[]; // Array of breadcrumbs (optional)
    title: string; // Page title
    rightContent?: React.ReactNode; // JSX for the right-side content
    titleSize?: string;
}

const TitleBar: React.FC<TitleBarProps> = ({ breadcrumbs, title, rightContent, titleSize = "h4" }) => {
    const navigate = useNavigate();

    const handleBreadcrumbClick = (href: string) => {
        navigate(href);
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 0,
            }}
        >
            {/* Left: Breadcrumbs and Title */}
            <Box>
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <Breadcrumbs aria-label="breadcrumb">
                        {breadcrumbs.map((crumb, index) =>
                            crumb.href ? (
                                <Link
                                    key={index}
                                    underline="hover"
                                    color="inherit"
                                    component="button"
                                    onClick={() => handleBreadcrumbClick(crumb.href!)}
                                    sx={{ 
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontFamily: 'inherit',
                                        fontSize: 'inherit'
                                    }}
                                >
                                    {crumb.label}
                                </Link>
                            ) : (
                                <Typography key={index} color="text.primary">
                                    {crumb.label}
                                </Typography>
                            )
                        )}
                    </Breadcrumbs>
                )}
                <Typography variant={titleSize as any} sx={{ mt: breadcrumbs && breadcrumbs.length > 0 ? 1 : 0 }}>
                    {title}
                </Typography>
            </Box>

            {/* Right: Custom Content */}
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                }}
            >
                {rightContent}
            </Box>
        </Box>
    );
};

export default TitleBar;
